import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, concatMap, map, of, switchMap, take } from 'rxjs';

import { loadPlayerStatisticsData, playerStatisticsDataFailure, playerStatisticsDataSuccess } from './player-statistics.actions';
import { PlayerStatistics, PlayerStatisticsStoreData } from './player-statistics.model';
import { PlayerStatisticsService } from './player-statistics.service';
import { selectDataByEventAndMarket } from './player-statistics.state';

@Injectable()
export class PlayerStatisticsEffects {
    actions$ = inject(Actions);
    store = inject(Store);
    playerStatsService = inject(PlayerStatisticsService);

    loadPlayerStatsData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadPlayerStatisticsData),
            concatMap((payload) => {
                const { eventId } = payload;
                const filter = 'mainMarket' in payload ? 'mainMarket' : payload.marketFilter;
                return this.store.select(selectDataByEventAndMarket(eventId, filter)).pipe(
                    take(1),
                    switchMap((existingStats) => this.handleExistingStatistics(existingStats, eventId, 'mainMarket' in payload, filter)),
                );
            }),
        ),
    );

    private handleExistingStatistics(existingStats: PlayerStatisticsStoreData, eventId: string, mainMarket: boolean, filter: string | undefined) {
        if (existingStats.isLoading) {
            return this.playerStatsService.fetchPlayerStats(eventId, mainMarket, filter).pipe(
                map((data: PlayerStatistics | undefined) =>
                    playerStatisticsDataSuccess({ eventId, marketFilter: filter, data: data ?? undefined, isLoading: false, isError: false }),
                ),
                catchError(() =>
                    of(playerStatisticsDataFailure({ eventId, marketFilter: filter, data: undefined, isLoading: false, isError: true })),
                ),
            );
        }
        return of();
    }
}
